import React, { useEffect, useState } from 'react';
import './CookieConsentBanner.css';

const COOKIE_CONSENT_KEY = 'pif_cookie_consent_v1';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show the banner if no consent has been recorded yet
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) {
      // Small delay for better UX
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const saveConsent = (choice) => {
    const payload = {
      choice,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-overlay" role="dialog" aria-modal="true" aria-describedby="cookie-desc">
      <div className="cookie-consent-modal">
        <div className="cookie-consent-content">
          <p id="cookie-desc" className="cookie-consent-text">
            We use essential cookies to make our site work. With your consent, we may also use non-essential cookies to improve user experience and analyze website traffic.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button type="button" className="cookie-btn cookie-btn-reject" onClick={() => saveConsent('rejected')}>
            Reject Non-Essential
          </button>
          <button type="button" className="cookie-btn cookie-btn-accept" onClick={() => saveConsent('accepted')}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

